import React, { memo } from "react";
import { css, useTheme } from "@emotion/react";

import {
    CATALOGS_WIDTH,
    VIDEO_WITH_4XL,
    VIDEO_WITH_LG,
    VIDEO_WITH_MD,
    VIDEO_WITH_SM,
    VIDEO_WITH_XL,
    VIDEO_WITH_XXL
} from "elements/Components/SegmentedVideo/includes/consts";

type Props = {
    className?: string,
    children: React.ReactNode,
};

const RightSection: React.FC<Props> = ({ className, children }) => {
    const theme = useTheme();

    const style = css`
        width: calc(100% - ${CATALOGS_WIDTH}px);

        ${theme.breakpoints.up("4xl")} {
            max-width: ${VIDEO_WITH_4XL}px;
        }

        ${theme.breakpoints.between("xxl", "3xl")} {
            max-width: ${VIDEO_WITH_XXL}px;
        }

        ${theme.breakpoints.only("xl")} {
            max-width: ${VIDEO_WITH_XL}px;
        }

        ${theme.breakpoints.only("lg")} {
            max-width: ${VIDEO_WITH_LG}px;
        }

        ${theme.breakpoints.only("md")} {
            width: ${VIDEO_WITH_MD}px;
        }

        ${theme.breakpoints.down("md")} {
            background-color: white;
        }

        ${theme.breakpoints.down("sm")} {
            min-width: ${VIDEO_WITH_SM}px;
            width: 100%;
        }
    `;

    return (
        <div css={style} className={className}>
            {children}
        </div>
    );
};

export default memo(RightSection);